import { Stack, Text } from '@chakra-ui/react';

import { SubmitButton } from '@/v5/components/atoms/Button/SubmitButton';
import { LinkButton } from '@/v5/components/atoms/Button/LinkButton';
import { Alert, AlertDescription, AlertIcon } from 'components/v4';
import MfaCodeBox from 'pages/auth/new/MfaWizard/MfaCodeBox';

import { styles } from '@/v5/@constants/login';
import { TcapHeading } from '@/v5/components/atoms/Heading/TcapHeading';

function LoginMfaForm({
    mfaCodeObj,
    mfaCodeError,
    shouldWeSwapToNextInput,
    shouldWeGoToPreviousInput,
    mfaCodeIndexDisabled,
    refs,
    hasEnteredCode,
    isInvalid,
    loading,
    onCancel,
}) {
    return (
        <>
            <Stack
                sx={{
                    marginBottom: '25px',
                }}>
                <TcapHeading>Enter your code</TcapHeading>
            </Stack>

            <Text fontSize="md" textAlign="center" color="gray.500">
                Enter the 6-digit security code from your authenticator app.
            </Text>

            <MfaCodeBox
                mfaCodeObj={mfaCodeObj}
                shouldWeSwapToNextInput={shouldWeSwapToNextInput}
                shouldWeGoToPreviousInput={shouldWeGoToPreviousInput}
                mfaCodeIndexDisabled={mfaCodeIndexDisabled}
                refs={refs}
                hasEnteredCode={hasEnteredCode}
            />

            {mfaCodeError && (
                <Alert status="error" sx={{ marginBottom: '25px' }}>
                    <AlertIcon />
                    <AlertDescription color="black">
                        The MFA code you entered is incorrect.
                    </AlertDescription>
                </Alert>
            )}

            <Stack flexDir="column" w="100%">
                <SubmitButton
                    isSubmitting={loading}
                    isDisabled={!hasEnteredCode || isInvalid}
                    mb="1px">
                    Continue
                </SubmitButton>
                <LinkButton
                    width="64px"
                    onClick={onCancel}
                    style={styles.linkButton}>
                    Go back
                </LinkButton>
            </Stack>
        </>
    );
}

export { LoginMfaForm };
